import React from 'react';

import ProductList from './../product-list/./product-list';
//@ts-ignore
import {GetCategoryBySlug,GetProductsByCategory} from './../../themes/kent/utilities/dataFunctions';

/**
 *
 * Product Row component
 * @extends {React.Component}
 */
interface IProps {
  category?: any;
  year?:any;
}

interface IState {
  products?:any;
  category?:any;
}


class ProductCategory extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state ={};
  }

  componentDidMount = async() =>{
    let category = await GetCategoryBySlug(this.props.category)
    let products = await GetProductsByCategory(category.id,this.props.year);
    this.setState({
      products:products,
      category:category
    })
  }
  public render(): JSX.Element {
    return (
     <div className="product-category secondary-background">
      {this.state.products && <ProductList year={this.props.year} products={this.state.products} />}
     </div>
    );
 }
}

 export default ProductCategory;
